import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'maintenances',
  initialState: {// initialize states
    items: {},
  },
  reducers: { // call reducers for save data
    update(state, action) {
      action.payload.forEach((item) => state.items[item.id] = item);
    },
  },
});

export { actions as maintenancesActions };
export { reducer as maintenancesReducer };
